import React from 'react';
import PropTypes from 'prop-types';

function AttentionCircle({ size, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke={stroke}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      />
      <path
        fill={stroke}
        stroke={stroke}
        strokeWidth="0.2"
        d="M17.0549 16.4226L17.0548 16.4228L7.03528 16.122L6.94954 16.0705L6.94955 16.0705C6.94959 16.0704 6.94963 16.0704 6.94968 16.0703L7.80852 14.6396C7.80853 14.6396 7.80854 14.6395 7.80855 14.6395C8.19522 13.9946 8.39979 13.2563 8.39979 12.504V11.2505C8.39979 9.26576 10.0151 7.65049 11.9998 7.65049C13.9845 7.65049 15.5998 9.26576 15.5998 11.2505V12.504C15.5998 13.2563 15.8043 13.9946 16.191 14.6395C16.191 14.6395 16.191 14.6396 16.191 14.6396L17.0499 16.0703C17.0499 16.0703 17.05 16.0704 17.05 16.0704C17.1152 16.1785 17.1164 16.3135 17.0549 16.4226ZM8.40905 14.9994L8.40902 14.9995L7.86798 15.9005H16.1317L15.591 14.9994C15.591 14.9994 15.591 14.9994 15.591 14.9994C15.1387 14.2459 14.8998 13.3831 14.8998 12.504V11.2505C14.8998 9.65121 13.5991 8.35048 11.9998 8.35048C10.4005 8.35048 9.09978 9.65121 9.09978 11.2505V12.504C9.09978 13.3831 8.86086 14.2459 8.40905 14.9994Z"
      />
      <path
        fill={stroke}
        stroke={stroke}
        strokeWidth="0.2"
        d="M12 5.9C12.6067 5.9 13.1 6.39327 13.1 7.00001V8.00002C13.1 8.19323 12.9432 8.35 12.75 8.35C12.5568 8.35 12.4 8.19322 12.4 7.99999V7.00001C12.4 6.77924 12.2208 6.60002 12 6.60002C11.7792 6.60002 11.6 6.77924 11.6 7.00001V8.00002C11.6 8.19323 11.4432 8.35 11.25 8.35C11.0568 8.35 10.9 8.19322 10.9 7.99999V7.00001C10.9 6.39327 11.3933 5.9 12 5.9Z"
      />
      <path
        fill={stroke}
        stroke={stroke}
        strokeWidth="0.2"
        d="M10.8317 16.0732L10.832 16.0727C10.9307 15.9061 11.1439 15.8521 11.3102 15.9474L11.3102 15.9474L11.311 15.9479C11.4781 16.0458 11.5343 16.2606 11.4362 16.4274C11.3805 16.5221 11.3495 16.637 11.3495 16.7502C11.3495 17.1085 11.6412 17.4002 11.9995 17.4002C12.3578 17.4002 12.6495 17.1085 12.6495 16.7502C12.6495 16.637 12.6185 16.5221 12.5628 16.4274L12.5628 16.4274L12.5625 16.4269C12.4654 16.26 12.5212 16.0459 12.6878 15.948L12.6878 15.948L12.6891 15.9472C12.856 15.8524 13.0689 15.9058 13.1672 16.073L13.1672 16.073L13.1673 16.0732C13.2868 16.2776 13.35 16.5116 13.35 16.7502V16.7502C13.35 17.4949 12.7447 18.1002 12 18.1002C11.2552 18.1002 10.6501 17.4949 10.649 16.7503V16.7502C10.649 16.5116 10.7121 16.2776 10.8317 16.0732Z"
      />
    </svg>
  );
}

AttentionCircle.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AttentionCircle;
